import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSite } from "@/lib/site";

const SOCIALS = [
  ["instagram", "Instagram"], ["tiktok", "TikTok"], ["facebook", "Facebook"],
  ["linkedin", "LinkedIn"], ["youtube", "YouTube"], ["threads", "Threads"], ["twitter", "X"],
];

export default function Footer() {
  const { settings } = useSite();
  const s = settings || {};
  const social = s.social || {};
  const year = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <p className="overline text-[11px] text-background/50 mb-6">Punya Brand yang Ingin Tumbuh?</p>
            <Link to="/contact" className="group inline-flex min-h-11 items-start py-1">
              <h2 className="font-display font-black tracking-tightest leading-[0.9] text-4xl sm:text-5xl md:text-7xl lg:text-8xl">
                Mari Bicara<span className="text-background/40">.</span>
              </h2>
              <ArrowUpRight className="w-8 h-8 md:w-12 md:h-12 mt-1 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </Link>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <p className="overline text-[10px] text-background/40 mb-4">Navigasi</p>
              <ul className="space-y-2.5 text-sm">
                {["Services", "Portfolio", "Blog", "About", "Contact"].map((l) => (
                  <li key={l}><Link to={`/${l.toLowerCase()}`} className="inline-flex min-h-11 items-center text-background/70 hover:text-background link-underline">{l}</Link></li>
                ))}
              </ul>
            </div>
            <div>
              <p className="overline text-[10px] text-background/40 mb-4">Social</p>
              <ul className="space-y-2.5 text-sm">
                {SOCIALS.filter(([k]) => social[k]).map(([k, label]) => (
                  <li key={k}><a href={social[k]} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center text-background/70 hover:text-background link-underline">{label}</a></li>
                ))}
                {!SOCIALS.some(([k]) => social[k]) && <li className="text-background/40 text-xs">Segera hadir</li>}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-background/15 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="font-display font-black text-3xl mb-2">{s.brand_name || "Digitalis"}<span className="text-background/40">.</span></div>
            <p className="text-sm text-background/60">{s.footer_tagline || "Digital Marketing Spesialist — Medan"}</p>
            <p className="overline text-[10px] text-background/40 mt-2">{s.footer_services_line || "Social Media • Creator • Google Maps • SEO"}</p>
          </div>
          <div className="text-sm text-background/50 md:text-right">
            <p>{s.city || "Medan"}, {s.province || "Sumatera Utara"}</p>
            <p className="mt-1">© {year} {s.brand_name || "Digitalis"}. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
